import { render, staticRenderFns } from "./goods-publish-table.vue?vue&type=template&id=8c75145a&"
import script from "./goods-publish-table.vue?vue&type=script&lang=js&"
export * from "./goods-publish-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports